'use client'

import { useSidebarStore } from '../hooks/sidebarStore'
import VendorContractsCard from '../components/dashboard/VendorContractsCard'
import VendorConfirmedReservations from '../components/dashboard/VendorConfirmedReservations'
import { useEffect, useState } from 'react'
import UserEarningsCard from '../components/userProfile/UserProfile'
import UserCreditInfo from '../components/UserCreditInfo'
import UserInfoCard from '../components/userProfile/UserInfoCard'
import apiService from '@/app/services/apiService'
import ContractsSalesSummaryCard from './ContractsSalesSummaryCard'
import ContractsEarningsCard from './ContractsEarningsCard'
import ContractsHistoryChart from './ContractsHistoryChart'

const DashboardPage = () => {
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)

  const [totalEarned, setTotalEarned] = useState<number | null>(null)
  const [totalSold, setTotalSold] = useState<number | null>(null)
  const [creditBalance, setCreditBalance] = useState<number | null>(null)
  const [tempCreditFee, setTempCreditFee] = useState<number | null>(null)
  const [user, setUser] = useState<{ name: string; email: string; date_joined: string } | null>(null)
  
  const { isCollapsed } = useSidebarStore()

  const [usedCredit, setUsedCredit] = useState<number | null>(null)
  const [totalCredit, setTotalCredit] = useState<number | null>(null)

  {/* const { data: creditData, error: creditError, isLoading: creditLoading } = useSWR(
    '/api/credits/balance/',
    apiService.getWithToken
  ); */}

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const response = await apiService.getWithToken('/api/user/dashboard/')

        setTotalEarned(response.total_earned)
        setTotalSold(response.total_shows_sold)
        setCreditBalance(response.credit_balance)
        setTempCreditFee(response.temp_credit_fee)
        setUser(response.user)
        setUsedCredit(response.credit_in_use)
        setTotalCredit(response.credit_total_generated)
      } catch (err) {
        console.error('Erro ao buscar dados do dashboard:', err)
        setError(true)
      } finally {
        setLoading(false)
      }
    }

    fetchDashboardData()
  }, [])

  if (loading) {
    return <p className="min-h-screen text-center mt-10">Carregando dados do painel...</p>
  }

  if (
    error ||
    totalEarned === null ||
    totalSold === null ||
    creditBalance === null ||
    tempCreditFee === null ||
    usedCredit === null ||
    totalCredit === null ||
    user === null
  ) {
    return <p className="text-center mt-10 text-red-600">Erro ao carregar dados do usuário.</p>
  }

  return (
    <main className={`min-h-screen px-4 py-10 sm:px-6 lg:px-8transition-all duration-300 ${isCollapsed ? 'md:ml-16' : 'md:ml-64'}`}>
      <h1 className="text-3xl font-bold text-gray-800 mb-8 text-center">Meu Dashboard</h1>

      <div className="max-w-4xl mx-auto px-4">
        {/* Outras seções do dashboard */}
        <VendorContractsCard />
        <VendorConfirmedReservations />
      </div>
      
      <div className="max-w-4xl mx-auto grid gap-6">
        <div className="grid gap-6 md:grid-cols-2">
          <UserInfoCard user={user} />
          <UserEarningsCard totalEarned={totalEarned} totalSold={totalSold} />
          {/*<UserCreditInfo
            availableCredit={creditData.available_credit}
            usedCredit={creditData.used_credit}
            totalCredit={creditData.total_credit}
          />*/}

          <UserCreditInfo
            availableCredit={creditBalance}
            usedCredit={usedCredit}
            totalCredit={totalCredit}
          />

          <ContractsSalesSummaryCard />
          <ContractsEarningsCard />
          <ContractsHistoryChart />
        </div>
      </div>
    </main>
  )
}

export default DashboardPage
